(function () {
  function applyDeviceSafeArea() {
    if (window.innerWidth > 767) return;

    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;bottom:0;height:env(safe-area-inset-bottom,0px);visibility:hidden;pointer-events:none;';
    document.body.appendChild(probe);
    var safeBottom = probe.offsetHeight;
    document.body.removeChild(probe);

    if (safeBottom > 0) {
      var footer = document.querySelector('footer.footer');
      if (footer) {
        var current = parseInt(getComputedStyle(footer).paddingBottom) || 0;
        footer.style.paddingBottom = (current + safeBottom) + 'px';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDeviceSafeArea);
  } else {
    applyDeviceSafeArea();
  }
})();
